import React from "react";
var __jsx = React.createElement;
import StaffBlade from './StaffBlade';
function StaffBladeAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(StaffBlade, {
    staffBladeData: entry,
    pageUrl: data.DynamicLayoutPage.url || 'staff',
    pageType: data.DynamicLayoutPage.pageType || 'Staff'
  });
}
export default StaffBladeAdapter;